export default {
    product: `商品`,
    products: `商品`,
    registerProduct: `添加商品`,
    mainInformation: '主要信息',
    searchCustomerDetailsAndLocations: '搜索客户详细信息和位置',
    searchCustomerByMarking: '通过唛头搜索客户',
    entry: '录入',
    barcode: '条形码',
    modifyItemsForEntry: '修改物品录入',
    updateProduct: '修改货物',
    item: '物品',
    addProductItem: '添加物品',
    updateProductItem: '更新物品',

    information: '信息',
    detailInformationDescribedTheProducts: '描述商品详细信息',
    containerInfo: '货柜信息',
    detailInformationAssignedToContainer: '货柜分配详细信息',
    detailInformationDescribedTheItems: '描述物品详细信息',
    updateProductInformation: '更新商品信息',
    updateItemInformation: '更新物品信息',
    updateProductImages: '更新商品图像',
    removeItem: '删除物品',
    areYouSureToDeleteThisItem: '确定要删除此物品吗?',
    yesIveConfirmed: '确认',
    savedImages: '图像保存',
    describedTheImageInformation: '描述图像信息',
    noImagesSaved: '无图像保存',
    dropImagesHereOrClickToSelectFilesForUpload: '拖图片到此处，或选择上传文件',
    clearAll: '清空',
    confirmUpload: '确认上传',
    galleryImage: '图库图像',

    mainlandIdentityCard: '大陆身份证',
    currentImage: '当前图像',
    previewImage: '预览图像',

    itemCode: '物品代码',
    scanningSuffix: '扫描后缀',
    prepayDepositFee: '预付定金费用',
    prepayTransportFee: '预付运输费用',
    companyPurchaseNo: '公司采购单号',
    handleUnit: '件数',
    dimension: '尺寸 (长x高x宽)',
    total: '总数',

    assignedDO: '已创建送货单',

    signedByUser: `签收人`,
    lastSaved: `最后更新`,

    unsaved: `未保存`,
    reset: `重置`,

    checkedInAt: `入仓时间`,

    changeOwner: `更换拥有权`,
    latestResultFor: `最新结果`,
    searchMarking: `搜索唛头`,
    searchRelatedProductsByTheMarking: `通过唛头搜索相关产品`,
    applyTo: `适用于`,
    confirmChangeOwnerToThisMarking: `确认更改此唛头的拥有权`,
    markingCannoyEmpty: `唛头不能空`,
    markingCannotBeSame: `唛头不能一样`,
    invalidMarkingInUpstream: `系统唛头无效`,
    markingIsTrashInUpstream: `系统唛头已删除`,
    markingIsDeletedInUpstream: `系统唛头已删除`,
    markingIsDisabledInUpstream: `系统唛头已停用`,
    invalidMarking: `错误唛头`,
    moreThanOneMarkingExists: `多个唛头出现`,
    upSteamSourceMarkingRemIdNotMatched: `系统 sourceMarkingRemid无法对上`,

    unit: 'UNIT',
    box: 'BOX',
    pallet: 'PALLET',
    wooden: 'WOODEN',
    long: 'LONG',

    // ------MUI------
    productName: '商品名称',
    signedBy: '收件人',
    addItems: '添加物品',

    gender: '性别',
    nation: '国家',
    dateOfBirth: '出生日期',
    identityNo: '身份证号码',
    department: '部门',
    validityTime: '有效日期'
}